module.exports = new __parcel__URL__("telepointer-spotlight-img.686800d4.png").toString();